import ical, { ICalEventStatus } from 'ical-generator'

function downloadTextFile(filename, fileBody)
{
  let element = document.createElement("a")
  element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(fileBody)}`)
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

function downloadMissionAsIcal(mission)
{
  const cal = ical({ name: 'Mein Wachplan' })
  let missions = []

  if(Array.isArray(mission)) {
    missions = missions.concat(mission)
  }
  else {
    missions.push(mission)
  }

  for( const m of missions ) {
    let e = cal.createEvent({
      description: m.excerpt,
      summary: m.title,
      start: m.start_date,
      end: m.end_date,
      organizer: {
        name: 'Mein Wachplan',
        email: 'noreply@mein-wachplan.de'
      },
    })
    e.allDay(true)
    if(m.is_canceled) e.status(ICalEventStatus.CANCELLED) 
  }
  downloadTextFile('wachplan.ics', cal.toString())
}

export { downloadMissionAsIcal }
